<template>
    <div :class="{ 'products-slider': true }">
        <div class="container">
            <div class="products-slider__header">
                <h2>{{ title }}</h2>
                <div class="products-slider__header__navigation">
                    <button
                        :class="{
                            'products-slider__header__navigation__btn': true,
                            [sliderNavPrevClass]: true,
                            '--prev': true,
                            disabled: isFirstItem
                        }"
                        type="button"
                        @click="switchToPrevSlide"
                    >
                        <svg><use xlink:href="@/themes/novaporta/assets/icons/sprite.svg#arrowRightIcon"></use></svg>
                    </button>
                    <hr />
                    <button
                        :class="{
                            'products-slider__header__navigation__btn': true,
                            [sliderNavNextClass]: true,
                            '--next': true,
                            disabled: isLastItem
                        }"
                        type="button"
                        @click="switchToNextSlide"
                    >
                        <svg><use xlink:href="@/themes/novaporta/assets/icons/sprite.svg#arrowRightIcon"></use></svg>
                    </button>
                </div>
            </div>
            <div
                :ref="sliderRefName"
                :class="{
                    'products-slider__conveyor': true,
                    swiper: true,
                    [this.sliderClass]: true
                }"
                @mouseenter="pauseAutoplay"
                @mouseleave="resumeAutoplay"
            >
                <div class="swiper-wrapper">
                    <div v-for="(item, idx) in products" :key="idx" class="swiper-slide products-slider__conveyor__item">
                        <ProductAgentComponent
                            :product="item"
                            :analyticProducts="analyticProducts"
                            :layoutType="'card'"
                            :borderSidesToVanish="borderHideSidesByIndex(idx)"
                        />
                    </div>
                </div>

                <!-- NAVIGATION -->
                <div class="products-slider__conveyor__navigation">
                    <button
                        :class="{
                            'products-slider__conveyor__navigation__btn': true,
                            [sliderNavPrevClass]: true,
                            '--prev': true,
                            disabled: isFirstItem
                        }"
                        type="button"
                        @click="switchToPrevSlide"
                    >
                        <svg><use xlink:href="@/themes/novaporta/assets/icons/sprite.svg#arrowRightIcon"></use></svg>
                    </button>
                    <hr />
                    <button
                        :class="{
                            'products-slider__conveyor__navigation__btn': true,
                            [sliderNavNextClass]: true,
                            '--next': true,
                            disabled: isLastItem
                        }"
                        type="button"
                        @click="switchToNextSlide"
                    >
                        <svg><use xlink:href="@/themes/novaporta/assets/icons/sprite.svg#arrowRightIcon"></use></svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes, { nullable } from 'vue-types';
import { Autoplay, Navigation, Pagination, Swiper, Thumbs } from 'swiper';
import { ProductAgent } from '@/themes/novaporta/components/reusable/ProductAgent/types';
import ProductAgentComponent from '@/themes/novaporta/components/reusable/ProductAgent';
import MyActionBtn from '@/themes/novaporta/components/ui/MyActionBtn';

import staticId from '~/mixins/static-id';

export default {
    name: 'ProductsSlider',
    mixins: [staticId],
    data() {
        return {
            isFirstItem: true,
            isLastItem: false,
            swiperInstance: null
        };
    },
    computed: {
        sliderRefName() {
            return `products-slider-${this.idStatic}`;
        },
        sliderClass() {
            return `-products-slider-${this.idStatic}`;
        },
        sliderNavPrevClass() {
            return `-products-slider-nav-prev-${this.idStatic}`;
        },
        sliderNavNextClass() {
            return `-products-slider-nav-next-${this.idStatic}`;
        },

        slider() {
            return this.$refs[this.sliderRefName].swiper;
        }
    },
    props: {
        title: VueTypes.string.isRequired,
        analyticProducts: VueTypes.any,
        products: VueTypes.arrayOf(VueTypes.oneOfType([ProductAgent, nullable])).isRequired
    },
    components: {
        ProductAgentComponent,
        MyActionBtn
    },
    watch: {
        products: {
            handler() {
                this.reinitializeSwiper();
            },
            deep: true
        }
    },
    methods: {
        borderHideSidesByIndex(idx) {
            if (idx === 0) return [];
            else return ['left'];
        },

        switchToNextSlide() {
            this.slider.slideNext();
        },
        switchToPrevSlide() {
            this.slider.slidePrev();
        },

        pauseAutoplay() {
            if (this.slider && this.slider.autoplay) {
                this.slider.autoplay.stop();
            }
        },
        resumeAutoplay() {
            if (this.slider && this.slider.autoplay) {
                this.slider.autoplay.start();
            }
        },

        subscribeForUpdatingSwiperData(newSwiper) {
            this.isFirstItem = newSwiper?.isBeginning;
            this.isLastItem = newSwiper?.isEnd;
        },

        initSwiper() {
            // !!! Use only on client side
            Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);

            this.swiperInstance = new Swiper(`.${this.sliderClass}`, {
                slidesPerView: 'auto',
                spaceBetween: 0,
                allowTouchMove: true,
                grabCursor: true,
                threshold: 5,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false
                },

                on: {
                    slideChange: newSwiper => {
                        this.subscribeForUpdatingSwiperData(this.swiperInstance);
                    },
                    init: newSwiper => {
                        this.subscribeForUpdatingSwiperData(this.swiperInstance);
                    }
                }
            });
        },

        destroySwiper() {
            if (this.swiperInstance) {
                this.swiperInstance?.destroy(true, true);
                this.swiperInstance = null;
            }
        },

        reinitializeSwiper() {
            this.destroySwiper();
            this.$nextTick(() => {
                this.initSwiper();
            });
        }
    },
    mounted() {
        this.initSwiper();
    }
};
</script>

<style lang="scss">
@import 'swiper/swiper.scss';
@import './styles.scss';
</style>
